var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditicon = function SvgEditicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "m8.91 4.324.32-.13.11-.328.79-2.382a.2.2 0 0 1 .186-.136h3.366c.083 0 .159.053.186.136l.79 2.381.11.329.32.13c.714.29 1.379.678 1.977 1.148l.274.215.34-.07 2.452-.504c.081-.017.165.02.208.095l1.683 2.927A.2.2 0 0 1 22 8.37l-1.66 1.88-.228.258.047.341a8.4 8.4 0 0 1 0 2.297l-.047.341.228.258 1.66 1.88c.057.065.067.16.023.235l-1.683 2.928a.195.195 0 0 1-.208.095l-2.452-.504-.34-.07-.274.214a8.2 8.2 0 0 1-1.977 1.149l-.32.13-.11.328-.79 2.382a.2.2 0 0 1-.186.136h-3.366a.2.2 0 0 1-.186-.136l-.79-2.382-.11-.328-.32-.13a8.2 8.2 0 0 1-1.977-1.149l-.273-.214-.34.07-2.453.503a.195.195 0 0 1-.208-.094l-.65.373.65-.373-1.683-2.928A.2.2 0 0 1 2 15.625l1.66-1.88.228-.258-.047-.341a8.4 8.4 0 0 1 0-2.297l.047-.34-.228-.259L2 8.37a.2.2 0 0 1-.024-.235L3.66 5.208l-.65-.374.65.374a.195.195 0 0 1 .208-.095l.151-.735-.15.735 2.452.504.34.07.273-.215A8.2 8.2 0 0 1 8.91 4.324Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.999,
    cy: 11.999,
    r: 4.05,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgEditicon;